import React, { useState, useEffect, Fragment, useRef } from "react";
import { useAppContext } from "../helpers/account-context";
import { submitLead } from "../helpers/apiEndpoints";

const FIELD_TYPES = [
  {
    name: "your_name",
    value: "name",
    type: "text",
    required: true,
  },
  {
    name: "your_email",
    value: "email",
    type: "email",
    required: true,
  },
  {
    name: "your_phone",
    value: "phone",
    type: "tel",
    required: false,
  },
  {
    name: "leave_a_message",
    value: "message",
    type: "textarea",
    required: false,
  },
];

const LeadForm = (props) => {
  const { account: { uid, lead_form, show_all_button }, getLocale} = useAppContext()
  const {
    filters, 
    results,
    onApplyFilters
  } = props;

  const [enabledLeadForm, setEnabledLeadForm] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmited, setIsSubmited] = useState(false);

  const formRef = useRef(null);
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    formData.append("captured_url", window.location.href);
    if(filters.geo && filters.geo.lat) {
      formData.append("lat", filters.geo.lat);
      formData.append("lng", filters.geo.lng);  
    }
    setIsLoading(true)
    submitLead(uid, Object.fromEntries(formData)).then((resp) => {
      setIsLoading(false)
      setIsSubmited(true)
      setEnabledLeadForm(false)
      e.target.reset();
    }).catch((err) => {
      setIsLoading(false)
      setEnabledLeadForm(false)
    });
  };
  
  useEffect(() => {
    setEnabledLeadForm(true)
  }, [filters])

  const handleShowAll = (e) => {
    e.preventDefault();
    onApplyFilters({all: 1})
  }
  if (!lead_form || !lead_form.enabled || !filters.isFiltered) return null;

  if(results.length > 0) return null;

  const isShowNoResults = results.length === 0;
  const isShowAllButton = results.length === 0 && show_all_button;
  const isShowForm = results.length === 0 && filters.isFiltered && enabledLeadForm
  return (

        <div className="cbmap-lead-form cbmap-scrollable">
          {
            !isSubmited && isShowNoResults && <div className="cbmap-no-results">{getLocale("no_results_found")}.</div>
          }    
          {
            isSubmited && <div className="cbmap-no-results">{getLocale("thank_you_for_reaching_out_to_us")}.</div>
          }    
          {isShowForm && 
          <Fragment>
          <p className="cbmap-lead-msg">
            {getLocale("get_notified_of_new_locations")}.
          </p>
          <form onSubmit={handleSubmit} ref={formRef}>
            {lead_form.fields.map((field) => {
              const fieldType = FIELD_TYPES.find((ft) => ft.value === field);
              if (!fieldType) return null;
              if (fieldType.value === "message") {
                return (
                  <textarea
                    key={fieldType.value}
                    name={`${fieldType.value}`}
                    placeholder={getLocale(fieldType.name)}
                    required={fieldType.required}
                    disabled={isLoading}
                  />
                );
              }
              return (
                <input
                  key={fieldType.value}
                  type={fieldType.type}
                  name={`${fieldType.value}`}
                  placeholder={getLocale(fieldType.name)}
                  required={fieldType.required}
                  disabled={isLoading}
                />
              );
            })}
            <button
              type="submit"
              disabled={isLoading}
              className="cbmap-btn cbmap-btn-primary cbmap-btn-submit-lead"
            >
              {getLocale("notify_me")}
            </button>
          </form>
          </Fragment>
          } 
          
          <div className="cbmap-show-all">
            {
              isShowAllButton && <button className="cbmap-btn cbmap-btn-primary cbmap-btn-show-all"
              onClick={handleShowAll}
             >
              {" "}
              {getLocale("show_all_locations")}
            </button>
            }
           
           </div>
        </div>

  );
};

export default LeadForm;
